{
  "appName": "Program Apporval in a Foreign Country (VA Form 22-0976)",
  "entryFile": "./app-entry.jsx",
  "entryName": "0976-edu-benefits",
  "rootUrl": "/school-administrators/apply-for-approval-program-in-foreign-country-form-22-0976",
  "productId": "33766335-1941-479b-a3a0-36b05ef39fa7"
}
